import {
    getOutdoorBarArticleByUid,
    GetOutdoorBarArticleByUidApiResponseSchema,
} from './get-outdoor-bar-article-by-uid';

export {
    GetOutdoorBarArticleByUidApiResponseSchema,
};

export const OutdoorBarArticlePageActions = {
    getOutdoorBarArticleByUid,
};
